// extracted by mini-css-extract-plugin
export default {"layout":"mainlayout_layout__LuiXA","wrapper":"mainlayout_wrapper__Qy8tq","mainContent":"mainlayout_mainContent__GQ2EF"};